import { useEffect, useState } from "react"

import { useConsole } from "contexts/Console"
import { useNavigation } from "contexts/Navigation"

import { A, Caption, Figure, ImgContainer, Selected } from "components/cards/subnavCommon"
import Image from "components/media/ImageCLD"
import ImageIM from "components/media/ImageIM"
import cldSrcSet from "components/retailer/cldSrcSet"
import { useEnv } from "contexts/Env"

export default function SubNavCard({ establishmentRetail, locate, isDealer, image_cld: image, link, title, heading, meta, slug, ...props }) {
  const console = useConsole()
  // console.log("🚀 ~ SubNavCard ~ establishmentRetail:", establishmentRetail)
  const env = useEnv()
  const navigation = useNavigation()

  const navigate = e => {
    e.preventDefault()
    navigation.navigate(e.target.getAttribute("href"))
  }
  const active = slug === navigation.slug
  const isGroupPage = !establishmentRetail?.establishment

  const retailerDetails = isGroupPage ? establishmentRetail?.dealer : establishmentRetail?.establishment

  const rswi = isGroupPage ? retailerDetails.defaultStoreImages : retailerDetails.rolexId
  const defaultRSWI = establishmentRetail?.dealer.defaultStoreImages
  console.log("🚀 ~ SubNavCard ~ rswi:", rswi, defaultRSWI)

  // const [miniSiteImages, setMiniSiteImages] = useState([])

  // let defautStoreSub
  // let defautStoreImgUrlSub
  // let subImages

  // const checkRswi = subImages ? rswi : retailerDetails?.urlRolexV7.split?.("-")?.[1].split?.("/")?.[1]
  // console.log("🚀 ~ SubNavCard ~ checkRswi:", checkRswi)
  // useEffect(() => {
  //   if (isGroupPage) {
  //     for (let index = 0; index < retailerDetails?.establishments.length; index++) {
  //       if (retailerDetails.rolexId === rswi) {
  //         defautStoreSub = isGroupPage ? retailerDetails?.establishments : retailerDetails.storeImages
  //       }
  //       retailerDetails.establishments.map(item => {
  //         if (item?.rolexId === checkRswi?.toUpperCase()) {
  //           defautStoreImgUrlSub = item?.storeImages
  //           subImages = JSON.parse(defautStoreImgUrlSub)
  //           setMiniSiteImages(subImages?.find?.(o => o.type === "cover-v6-mobile"))
  //         }
  //       })
  //       break
  //     }
  //   } else {
  //     if (retailerDetails?.rolexId === checkRswi?.toUpperCase()) {
  //       defautStoreImgUrlSub = retailerDetails?.storeImages
  //       if (defautStoreImgUrlSub !== "") {
  //         subImages = JSON.parse(defautStoreImgUrlSub)
  //         setMiniSiteImages(subImages?.find?.(o => o.type === "cover-v6-mobile"))
  //       }
  //     }
  //   }
  // }, [isGroupPage, retailerDetails, rswi, checkRswi])

  // const rocc_bg = {
  //   alt: "Group img",
  //   loading: "eager",
  //   sources: [
  //     {
  //       src: miniSiteImages?.url,
  //       width: 840,
  //       height: 560,
  //       media: "(max-aspect-ratio: 16/9)",
  //     },
  //   ],
  // }

  // const isEstablishmentLink = () => {
  //   // split link to get the last part of the url and it has to be :establishment
  //   const splitLink = link.split("/")
  //   const lastPart = splitLink[splitLink.length - 1]
  //   return lastPart === ":establishment"
  // }

  // const isRoccBgSrcFilled = () => {
  //   return miniSiteImages?.url
  // }
  const defaultImage = link.endsWith(":dealer")
    ? cldSrcSet(`/image/upload/d_retailers:a_generic:cover-mobile.jpg/q_auto/f_auto/c_limit,w_%w%/v1/retailers/${defaultRSWI}/cover-mobile.jpg`, {
        env,
      })
    : cldSrcSet(`/image/upload/d_retailers:a_generic:cover-mobile.jpg/q_auto/f_auto/c_limit,w_%w%/v1/retailers/${rswi}/cover-mobile.jpg`, {
        env,
      })

  console.verbose("SubNavCardRetailer(%o)", { link, title, props }, locate, retailerDetails, image)
  return (
    <A className={active && "current"} href={navigation.localize(slug)} onClick={navigate} style={{ "--i": meta.index, "--reverse-i": meta.reverseIndex }}>
      {active && <Selected />}
      <Figure>
        <ImgContainer className='img-cont'>
          {link.endsWith(":dealer") || link.endsWith(":establishment") ? <img srcSet={defaultImage} loading='lazy' alt='' /> : <Image {...image} />}
          {/* {isRoccBgSrcFilled() && isEstablishmentLink() ? <ImageIM className='rocc_img' {...rocc_bg} /> : <Image {...image} />} */}
        </ImgContainer>
        <Caption>
          {heading?.kicker && <span className='kicker' dangerouslySetInnerHTML={{ __html: heading.kicker }} />}
          {heading?.title && <span className='title' dangerouslySetInnerHTML={{ __html: heading.title.replace("$name", establishmentRetail.dealer.name) }} />}
          {heading?.subtitle && <span className='subtitle' dangerouslySetInnerHTML={{ __html: heading.subtitle }} />}
        </Caption>
      </Figure>
    </A>
  )
}
